import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    AMARON__CALL__LOG__FORM__ID,
    isAmaronWorkspace,
} from "~/domainModels/workspaceSpecific/amaron";
import {
    BOBCARD__CALL__LOG__FORM__ID,
    isBobcardWorkspace,
} from "~/domainModels/workspaceSpecific/bobcard";
import {
    DHIRAAGU__CALL__LOG__FORM__ID,
    isDhiraaguWorkspace,
} from "~/domainModels/workspaceSpecific/dhiraagu";
import {
    DULUX__CALL__LOG__FORM__ID,
    isDuluxWorkspace,
} from "~/domainModels/workspaceSpecific/dulux";
import {
    EMOTORAD__CALL__LOG__FORM__ID,
    isEmotoradWorkspace,
} from "~/domainModels/workspaceSpecific/emotorad";
import type {WorkspaceCapability} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import {resolveConfigFormHref} from "~/workspaceConfig/configHref";

function logCallFormId(
    workspace: {id: Uuid; displayName: string},
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>,
): Uuid | null {
    if (isEmotoradWorkspace(workspace) === true) {
        return EMOTORAD__CALL__LOG__FORM__ID;
    }
    if (isAmaronWorkspace(workspaceCapabilities) === true) {
        return AMARON__CALL__LOG__FORM__ID;
    }
    if (isDuluxWorkspace(workspaceCapabilities) === true) {
        return DULUX__CALL__LOG__FORM__ID;
    }
    if (isBobcardWorkspace(workspace) === true) {
        return BOBCARD__CALL__LOG__FORM__ID;
    }
    if (isDhiraaguWorkspace(workspace) === true) {
        return DHIRAAGU__CALL__LOG__FORM__ID;
    }
    return null;
}

/** Config FormPage href for the workspace log-call form. Empty when the page is not configured. */
export function resolveWorkspaceLogCallRoute(
    workspace: {id: Uuid; displayName: string},
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>,
): string {
    const formId = logCallFormId(workspace, workspaceCapabilities);
    if (formId === null) {
        return "";
    }
    return resolveConfigFormHref({workspaceId: workspace.id, formId}) ?? "";
}
